/**
 * Synthesize a cash-register ding ("chinchín") using Web Audio API.
 * No external asset needed.
 */
let _ctx = null;

function getCtx() {
    if (typeof window === "undefined") return null;
    if (!_ctx) {
        const Ctor = window.AudioContext || window.webkitAudioContext;
        if (!Ctor) return null;
        _ctx = new Ctor();
    }
    return _ctx;
}

function ding(freq, startTime, duration = 0.18) {
    const ctx = getCtx();
    if (!ctx) return;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, startTime);
    gain.gain.setValueAtTime(0.0001, startTime);
    gain.gain.exponentialRampToValueAtTime(0.35, startTime + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(startTime);
    osc.stop(startTime + duration);
}

/**
 * Play the iconic 2-tone cash register sound.
 * Safe to call from a user-gesture handler; first call resumes the AudioContext.
 */
export function playCashRegister() {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === "suspended") {
        ctx.resume().catch(() => {});
    }
    const t0 = ctx.currentTime;
    // High then higher: 1318 (E6) → 1760 (A6)
    ding(1318.5, t0, 0.16);
    ding(1760, t0 + 0.13, 0.22);
}
